import React from 'react'
import {
  getVirtualBundles,
  setSelectedVirtualBundeDetails,
  setPage,
  setRowsPerPage,
  setCSVDownloadSuccess,
} from '../../store/virtualBundles/actionCreator'
import { useDispatch, useSelector } from 'react-redux'
import FlexibleTable from 'components/EnhancedTable/FlexibleTable'
import Grid from '@mui/material/Grid'
import {
  columnData,
  clickableColumn,
  groupStates,
  mvtOptions,
} from './VirtualBundlesConstants'
import { setHeaderTitleArray } from '../../store/layout/actionCreator'
import { makeStyles } from '@material-ui/core/styles'
import { useNavigate } from 'react-router'
import { createCsvUtil } from './VirtualBundleUtil'
import {
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from '@mui/material'
import { IconButton, InputAdornment } from '@material-ui/core'
import { Clear, Search } from '@material-ui/icons'
import { findIndex } from 'lodash'
const useStyles = makeStyles((theme) => ({
  wrapper: {
    alignItems: 'center',
    display: 'flex',
    height: '100%',
    left: '0',
    top: '0',
    width: '100%',
  },
  tabButton: {
    width: 'auto',
    margin: '0px 8px',
    float: 'right',
  },
  defaultButton: {
    width: 'auto',
    margin: '0px 8px',
    color: 'white',
  },
  content: {
    boxSizing: 'border-box',
    margin: '0 auto',
    padding: '20px 269px',
  },
  unAuthContent: {
    textAlign: 'center',
  },
  containerStyle: {
    paddingBottom: 10,
    float: 'right',
  },
  appBar: {
    backgroundColor: 'white',
    position: 'relative',
    height: '35px',
    textAlign: 'center',
    width: '100%',
    float: 'left',
    boxShadow: 'none',
  },
  appBarFlyout: {
    backgroundColor: theme.palette.secondary.main,
    position: 'relative',
    height: '55px',
    textAlign: 'center',
    width: '100%',
    boxShadow: 'none',
  },
  popoverText: {
    float: 'left',
    color: 'black',
    fontSize: 15,
    fontWeight: 'bold',
  },
  heading: {
    fontWeight: 'bold',
    fontSize: '34px',
    margin: '0',
    color: '#CC0000',
  },
  swipeableDrawer: {
    paddingRight: '2%',
    paddingLeft: '2%',
    paddingTop: '10px',
    paddingBottom: '13px',
    overflow: 'hidden',
    height: '60px',
    alignItems: 'center',
  },
  swipeableDrawerElementsContainer: {
    overflow: 'hidden',
    backgroundColor: '#366cd9',
  },
  subheading: {
    fontWeight: '400',
    fontSize: '18px',
    lineHeight: '1.5',
    margin: '1.8em 10px 2em',
  },
  pageHeader: {
    width: '100%',
    height: '40px',
    position: 'relative',
    marginTop: '5px',
  },
  drawer: {
    '& .MuiDrawer-paperAnchorBottom': {
      position: 'fixed',
      left: 'calc(100% - 900px)',
    },
  },
  uploadButton: {
    maxWidth: '400px',
    width: 'auto',
    margin: theme.spacing(1),
  },
}))
const VirtualBundles = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [tcinFilter, setTcinFilter] = React.useState('')
  const [groupStateFilter, setGroupStateFilter] = React.useState('ALL')
  const [titleFilter, setTitleFilter] = React.useState('')
  const [mvtFilter, setMvtFilter] = React.useState('OB')
  const [selectedTcins, setSelectedTcins] = React.useState([])

  const {
    virtualBundles = [],
    requestPending = false,
    totalRowsCount = 0,
    page = 1,
    rowsPerPage = 25,
    csvDownloadData = [],
    csvDownloadPending = false,
  } = useSelector(
    ({
      virtualBundlesReducer: {
        virtualBundles = [],
        requestPending = false,
        totalRowsCount = 0,
        page = 1,
        rowsPerPage = 25,
        csvDownloadData = [],
        csvDownloadPending = false,
      },
    }) => {
      return {
        virtualBundles,
        requestPending,
        totalRowsCount,
        page,
        rowsPerPage,
        csvDownloadData,
        csvDownloadPending,
      }
    }
  )
  const finalVirtualBundles = virtualBundles?.map((dobj = {}, index) => {
    const { childTcinSamplesReqTotalQty = Number(0) } = dobj
    return Object.assign({}, dobj, {
      isAnErrorRow: !childTcinSamplesReqTotalQty,
    })
  })
  React.useEffect(() => {
    dispatch(setHeaderTitleArray([{ title: 'Virtual Bundles' }]))
  }, [])

  React.useEffect(() => {
    const params = getVirtualBundlesParams(false)
    if (groupStateFilter !== 'ALL') {
      params['group_state'] = groupStateFilter
    }
    dispatch(
      getVirtualBundles(params, false, page, rowsPerPage, totalRowsCount)
    )
  }, [page, rowsPerPage, dispatch, groupStateFilter, mvtFilter])
  React.useEffect(() => {
    if (csvDownloadData.length > 0) {
      const csvData = new Blob([createCsv(csvDownloadData)], {
        type: 'text/csv',
      })
      const csvUrl = URL.createObjectURL(csvData)
      const link = document.createElement('a')
      link.href = csvUrl
      link.setAttribute('download', 'Virtual Bundles.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }, [csvDownloadData])
  React.useEffect(() => {
    return () => {
      dispatch(setCSVDownloadSuccess([]))
      setSelectedTcins([])
    }
  }, [])
  const setPageLocal = (newPage) => {
    dispatch(setPage(newPage))
  }
  const onSelected = (selectedData, selected) => {
    const { vbParentTcin = '' } = selected
    return (
      findIndex(selectedData, function (obj) {
        return obj === vbParentTcin
      }) !== -1
    )
  }
  
  const setRowsPerPageLocal = (newRowsPerPage) => {
    dispatch(setRowsPerPage(newRowsPerPage))
  }
  const handleGetVirtualBundleDetails = (e) => {
    const { vbParentTcin = '' } = e
    const selectedVirtualBundleDetails = virtualBundles.find(
      (bundle) => bundle.vbParentTcin === vbParentTcin
    )
    navigate(`/virtualBundles/virtualBundleDetails/${vbParentTcin}`)
    dispatch(setHeaderTitleArray([{ title: 'Virtual Bundle Details' }]))
    dispatch(setSelectedVirtualBundeDetails(selectedVirtualBundleDetails))
  }
  const setCheckBox = (selectedData = []) => {
    if (selectedTcins.includes(selectedData.vbParentTcin)) {
      setSelectedTcins(
        selectedTcins.filter((tcin) => tcin !== selectedData.vbParentTcin)
      )
      return
    } else {
      setSelectedTcins([...selectedTcins, selectedData.vbParentTcin])
    }
  }
  const setCheckBoxHeaderChange = (selectedData = []) => {
    // Count how many of the passed rows are already in selectedTcins
    const selectedDiffCount = selectedData.filter((item) =>
      selectedTcins.includes(item.vbParentTcin)
    ).length

    if (selectedDiffCount === selectedData.length) {
      setSelectedTcins(
        selectedTcins.filter(
          (tcin) => !selectedData.some((item) => item.vbParentTcin === tcin)
        )
      )
    } else {
      const newTcins = selectedData
        .map((item) => item.vbParentTcin)
        .filter((tcin) => tcin && !selectedTcins.includes(tcin))
      setSelectedTcins([...selectedTcins, ...newTcins])
    }
  }
  const createCsv = (data) => {
    return createCsvUtil(data)
  }
  const getVirtualBundlesParams = (virtualBundleDownload = true) => {
    const params = {
      tcins: virtualBundleDownload ? selectedTcins : [tcinFilter],
      mvt: mvtFilter,
    }
    if (titleFilter) {
      params.name = titleFilter
    }
    if (groupStateFilter && groupStateFilter !== 'ALL') {
      params.groupState = groupStateFilter
    }
    return params
  }
  const downloadFunction = () => {
    const params = getVirtualBundlesParams(false)
    dispatch(getVirtualBundles(params, true, page, rowsPerPage, totalRowsCount))
  }
  const searchTcins = () => {
    const params = getVirtualBundlesParams(false)
    dispatch(getVirtualBundles(params, page, rowsPerPage, totalRowsCount))
  }
  const virtualBundleDownloadFunction = () => {
    const data = virtualBundles.filter((bundle) =>
      selectedTcins.includes(bundle.vbParentTcin)
    )
    dispatch(setCSVDownloadSuccess(data))
  }
  const clearTcins = (filterName = '') => {
    switch (filterName) {
      case 'TCIN':
        setTcinFilter('')
        break
      case 'TITLE':
        setTitleFilter('')
        break
      case 'GROUP_STATE':
        setGroupStateFilter('ALL')
        break
      case 'MVT':
        setMvtFilter('all')
        break
      default:
        setTcinFilter('')
        setTitleFilter('')
        setGroupStateFilter('ALL')
        break
    }
    const params = {
      tcins: [],
      mvt: 'OB',
    }
    dispatch(
      getVirtualBundles(params, false, page, rowsPerPage, totalRowsCount)
    )
  }
  return (
    <Grid>
      <Grid container spacing={2} style={{ margin: 16 }}>
        <Grid item>
          <TextField
            label="Filter by TCIN"
            variant="outlined"
            size="small"
            style={{ width: '800px' }}
            value={tcinFilter}
            onChange={(e) => setTcinFilter(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                searchTcins()
              }
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <IconButton onClick={() => searchTcins()}>
                    <Search />
                  </IconButton>
                  <IconButton onClick={() => clearTcins('TCIN')}>
                    <Clear />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item>
          <FormControl variant="outlined" size="small">
            <InputLabel id="group-state-label">Group State</InputLabel>
            <Select
              labelId="group-state-label"
              label="Group State"
              value={groupStateFilter}
              onChange={(e) => setGroupStateFilter(e.target.value)}
              style={{ minWidth: 140 }}
            >
              {groupStates.map((state) => (
                <MenuItem key={state} value={state}>
                  {state}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item>
          <FormControl variant="outlined" size="small">
            <InputLabel id="group-state-label">MVT</InputLabel>
            <Select
              labelId="group-state-label"
              label="MVT"
              value={mvtFilter}
              onChange={(e) => setMvtFilter(e.target.value)}
              style={{ minWidth: 140 }}
            >
              {mvtOptions.map((state) => (
                <MenuItem key={state} value={state}>
                  {state}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item>
          <Grid item>
            <TextField
              label="Filter by Name"
              variant="outlined"
              size="small"
              value={titleFilter}
              onChange={(e) => setTitleFilter(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  searchTcins()
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="start">
                    <IconButton onClick={() => searchTcins()}>
                      <Search />
                    </IconButton>
                    <IconButton onClick={() => clearTcins('TITLE')}>
                      <Clear />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <span style={{ fontSize: 14, fontStyle: 'italic', color: '#B85300' }}>
          Only VBPs approved for publishing are available for ordering.
        </span>
      </div>
      <FlexibleTable
        cascadeFieldKeys={[]}
        columnData={columnData}
        data={finalVirtualBundles}
        enableSearch
        paginationAtApiLevel={true}
        page={page}
        rowsPerPage={rowsPerPage}
        totalRowsCount={totalRowsCount}
        setPage={(e) => setPageLocal(e)}
        setRowsPerPage={(e) => setRowsPerPageLocal(e)}
        isLoading={requestPending}
        clickableColumn={clickableColumn}
        enableMultiSearch={true}
        clickableRowButton="OPEN"
        showPopup={(e) => handleGetVirtualBundleDetails(e)}
        enableDownload={virtualBundles.length > 0}
        downloadFunction={(e) => downloadFunction(e)}
        downloadLoadingStatus={csvDownloadPending}
        errorRowTooltipMessage="Invalid item / No VBCs configured"
        enableScrolls
        checkBoxEnabled
        onCheckBoxChange={setCheckBox}
        onCheckBoxHeaderChange={setCheckBoxHeaderChange}
        selected={selectedTcins}
        uniqueIdentifierInData="vbParentTcin"
        virtualBundleDownload={selectedTcins.length > 0}
        virtualBundleDownloadFunction={virtualBundleDownloadFunction}
        numSelected={selectedTcins.length}
        onSelected={onSelected}
      />
    </Grid>
  )
}

export default VirtualBundles
